import { render, staticRenderFns } from "./RefsPanel.vue?vue&type=template&id=cebea1d2&scoped=true&"
import script from "./RefsPanel.vue?vue&type=script&lang=js&"
export * from "./RefsPanel.vue?vue&type=script&lang=js&"
import style0 from "./RefsPanel.vue?vue&type=style&index=0&id=cebea1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebea1d2",
  null
  
)

export default component.exports